import { Colors } from '..';
import generateGradient from './generateGradient';

const primary = {
  conical: generateGradient(
    [Colors.Primary[600], Colors.Primary[25]],
    'conical',
    {},
    {
      originDeg: 259.08,
      originX: 50,
      originY: 50,
      deg: [0, 360],
    }
  ),
  linear01: generateGradient(
    [Colors.Primary[600], Colors.Primary[500]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear02: generateGradient(
    [Colors.Primary[700], Colors.Primary[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear03: generateGradient(
    [Colors.Primary[800], Colors.Primary[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
  linear04: generateGradient(
    [Colors.Primary[800], Colors.Primary[600]],
    'linear',
    {
      originDeg: 90,
      percent: [0, 100],
    }
  ),
  linear05: generateGradient(
    [Colors.Primary[800], Colors.Primary[700]],
    'linear',
    {
      originDeg: 26.5,
      percent: [0, 100],
    }
  ),
  linear06: generateGradient(
    [Colors.Primary[900], Colors.Primary[600]],
    'linear',
    {
      originDeg: 45,
      percent: [0, 100],
    }
  ),
} as const;

export default primary;
